import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { useState } from "react";
import ContainedButton from "../../../../components/buttons/ContainedButton";
import GuidelineStep from "../components/GuidelineStep";

const OnPremSetupStep = ({ onSubmit, guideMode, isLoading }) => {
  const [DomainControllerPrimaryIp, setDomainControllerPrimaryIp] =
    useState("");
  const [DomainControllerSecondaryIp, setDomainControllerSecondaryIp] =
    useState("");
  const [adDomainName, setAdDomainName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = () => {
    if (onSubmit) {
      onSubmit({
        DomainControllerPrimaryIp,
        DomainControllerSecondaryIp,
        adDomainName,
        username,
        password,
      });
    }
  };

  return (
    <GuidelineStep title="Configure On-Prem Connection">
      <Box width={700} display="flex" flexDirection="column" gap={2}>
        <TextField
          placeholder="Primary Domain Controller IP Address"
          fullWidth
          type="text"
          value={DomainControllerPrimaryIp}
          onChange={(e) => setDomainControllerPrimaryIp(e.target.value)}
          disabled={guideMode}
          helperText="IP address of your primary Domain Controller server"
        />
        <TextField
          placeholder="Secondary Domain Controller IP Address"
          fullWidth
          type="text"
          value={DomainControllerSecondaryIp}
          onChange={(e) => setDomainControllerSecondaryIp(e.target.value)}
          disabled={guideMode}
          helperText="IP address of your secondary Domain Controller server"
        />
        <TextField
          placeholder="AD Domain Name"
          fullWidth
          type="text"
          value={adDomainName}
          onChange={(e) => setAdDomainName(e.target.value)}
          disabled={guideMode}
        />
        <TextField
          placeholder="AD Username"
          fullWidth
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={guideMode}
        />
        <TextField
          placeholder="AD User Password"
          fullWidth
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={guideMode}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword((prev) => !prev)}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <ContainedButton
          onClick={handleSubmit}
          size="small"
          color="primary"
          disabled={
            guideMode ||
            !DomainControllerPrimaryIp ||
            !DomainControllerSecondaryIp ||
            !adDomainName ||
            !username ||
            !password
          }
          loading={isLoading}
        >
          Connect
        </ContainedButton>
      </Box>
    </GuidelineStep>
  );
};

export default OnPremSetupStep;
